export const isRecord = (value: unknown): value is Record<string, unknown> => {

    return typeof value === "object" && value !== null && !Array.isArray(value);

};

